export { default } from './InputLabel'
